// Career search form
// @ts-ignore
/* eslint-disable */

let currentPage = 1;
const form = document.getElementById('searchform');
const searchInput = document.getElementById('s');
const cityInput = document.getElementById('city');
const departmentInput = document.getElementById('department');
const customSelects = document.querySelectorAll('.custom-select');
const resourcesSearchRemove = document.querySelector('.js-resources-search-remove');
let cityValue;
let departmentValue;

customSelects.forEach(function (select, i) {
    const selectTrigger = select.querySelector('.select-trigger');
    const selectedOption = select.querySelector('.selected-option');
    const optionsList = select.querySelector('.options');
    const options = select.querySelectorAll('.options li');

    // Toggle options list visibility
    selectTrigger.addEventListener('click', function () {
        // Check if the selectTrigger has the "active" class
        const isActive = selectTrigger.classList.contains('active');

        // Close all selects if the current one is not active
        if (!isActive) {
            closeAllSelects();
        }

        // Toggle the "active" class on the selectTrigger
        selectTrigger.classList.toggle('active');

        // Toggle the options list visibility based on the "active" class
        optionsList.style.display = isActive ? 'none' : 'block';
    });

    // Set selected option and hide options list
    options.forEach(function (option) {
        option.addEventListener('click', function () {
            const value = option.getAttribute('data-value');
            selectedOption.textContent = option.textContent;
            optionsList.style.display = 'none';
            selectTrigger.classList.remove('active');

            // Perform desired actions based on selected value
            if (i === 0) {
                departmentValue = value;
            } else {
                cityValue = value;
            }
            submitSearch();
        });
    });
});

// Function to close all selects
function closeAllSelects() {
    customSelects.forEach(function (select) {
        const selectTrigger = select.querySelector('.select-trigger');
        const optionsList = select.querySelector('.options');

        // Remove the "active" class and hide options list
        selectTrigger.classList.remove('active');
        optionsList.style.display = 'none';
    });
}


// Close all selects when a click occurs outside
document.addEventListener('click', function (event) {
    if (!event.target.closest('.custom-select')) {
        // eslint-disable-next-line
        closeAllSelects();
    }
});

// Function to close all selects
function closeAllSelects() {
    const optionsLists = document.querySelectorAll('.options');
    const selectTriggers = document.querySelectorAll('.select-trigger');
    optionsLists.forEach(function (optionsList) {
        // eslint-disable-next-line
        optionsList.style.display = 'none';
    });
    selectTriggers.forEach(function (selectTriggers) {
        // eslint-disable-next-line
        selectTriggers.classList.remove('active');
    });
}

if(form) {
    form.addEventListener('keydown',function(e) {
        if (e.keyIdentifier=='U+000A' || e.keyIdentifier=='Enter' || e.keyCode==13) {
            if (e.target.nodeName=='INPUT' && e.target.type=='text') {
                e.preventDefault();

                return false;
            }
        }
    }, true);
}


const liveSearch = document.getElementById('livesearch');
const searchResults = document.getElementById('searchResults');

// eslint-disable-next-line func-names
const submitSearch = function (event) {
    if (event) event.preventDefault();
    let searchValue = '';
        searchValue = searchInput?.value.trim();
    const existingShowMoreButton = document.getElementById('showMoreRoles');
    const data = new FormData();

    if (event?.type === 'change' || !event) {
        data.append('event', 'search');
    }
    if (event?.type === 'change') {
        searchResults.innerHTML = '';
        currentPage = 1;
    }

    data.append('page', currentPage.toString());
    data.append('action', 'careers_search');
    data.append('searchValue', searchValue);
    data.append('city', cityValue ? cityValue.toString() : '');
    data.append(
        'department',
        departmentValue ? departmentValue.toString() : ''
    );

    fetch(window.var_from_php.ajax_url, {
        method: 'POST',
        credentials: 'same-origin',
        body: data,
    })
        .then(function (response) {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.text();
        })
        .then(function (result) {
            if ( event?.type === 'input' && event instanceof InputEvent) {
                liveSearch.innerHTML = result;
                const resultTitle = document.querySelectorAll('.livesearch__item');

                resultTitle.forEach((item) => {
                    item.addEventListener('click', () => {
                        currentPage = 1;
                        searchInput.value = item.textContent.trim(); // Append item value to searchInput
                        resourcesSearchRemove.classList.add('active');
                        liveSearch.innerHTML = '';
                        submitSearch();
                        searchResults.innerHTML = '';
                    });
                });

                resultTitle &&
                resultTitle.forEach((text) => {
                    const target = event.target;
                    const content = text.innerHTML;
                    const highlightedContent = content.replace(new RegExp(target?.value, 'gi'), (match) => {
                        return `<span class='highlight'>${match}</span>`;
                    });
                    // eslint-disable-next-line no-param-reassign
                    text.innerHTML = highlightedContent;
                });
            } else if ( event instanceof InputEvent && event?.data === null ) {
                liveSearch.innerHTML = '';
            } else {
                if (currentPage > 1) {
                    // Append new results to the existing content
                    if (existingShowMoreButton) {
                        existingShowMoreButton.insertAdjacentHTML('beforebegin',
                            result);
                        existingShowMoreButton.remove();
                    }
                } else {
                    liveSearch.innerHTML = '';
                    // Remove existing "Show More" button
                    if (existingShowMoreButton) {
                        existingShowMoreButton.remove();
                    }
                    // Append new results (and potentially a new "Show More" button)
                    searchResults.innerHTML = '';
                    searchResults.innerHTML += result;
                }
                if (window.location.hash) {
                    // Get the hash without the '#' symbol
                    const hash = window.location.hash.substring(1);
                    // Find the element with the ID that matches the hash
                    const element = document.getElementById(hash);
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth' });

                        // Add some space before the scrolled position
                        const yOffset = -100; // Adjust this value as needed
                        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                        window.scrollTo({ top: y, behavior: 'smooth' });
                        element.classList.add('expanded');

                        const txtMoreDiv = element.querySelector('.txt_more');
                        if (txtMoreDiv) {
                            txtMoreDiv.style.display = 'flex';
                        }
                    }
                }
            }
            const showMoreButton = document.getElementById('showMoreRoles');
            if(showMoreButton) {
                const maxPages = showMoreButton.getAttribute('data-pages');

                if (maxPages > currentPage) {
                    showMoreButton.addEventListener('click', function () {
                        currentPage += 1;
                        submitSearch();
                    });
                } else {
                    showMoreButton.remove();
                }
            }

            // Start -> Expand Full Role
            const scrollEls = document.getElementsByClassName('btn_more');
            Array.from(scrollEls).forEach((el) => {
                el.addEventListener('click', (e) => {
                    if (el?.nextSibling?.style.display === 'none') {
                        // eslint-disable-next-line no-param-reassign
                        el.nextSibling.style.display = 'flex';
                        // eslint-disable-next-line no-param-reassign
                        el.parentElement.classList.add('expanded');
                        e.target.innerText = window.rock_pll_e.see_less;
                        e.target.classList.add('btn_more-none');
                    } else {
                        // eslint-disable-next-line no-param-reassign
                        el.nextSibling.style.display = 'none';
                        el.parentElement.classList.remove('expanded');
                        e.target.innerText = window.rock_pll_e.learn_more;
                    }
                });
            });
            // End -> Expand Full Role

            // Start -> Show Apply form
            const applyButtons = document.getElementsByClassName('apply-button');
            const applyClose = document.getElementById('apply_close');
            const wrapperNode = document.getElementById('main-wrapper');
            const inputLink = document.getElementById('link-role');
            const rolePosition = document.getElementById('role-position');
            const applyFormWrapper = document.querySelector('.apply-form__wrapper');
            const positionInput = document.getElementById('position-input');
            const roleDepartment =
                document.getElementById('role-department');

            Array.from(applyButtons).forEach((element) => {
                // Add event listener to each element
                // eslint-disable-next-line no-shadow
                const contactForm = document.querySelector('.wpcf7-form');

                element.addEventListener('click', (event) => {
                    event.preventDefault();
                    // Your event handling logic here
                    const grandparentElement =
                        element.parentElement.parentElement;
                        contactForm.classList.remove('invalid');

                    rolePosition.innerHTML =
                        grandparentElement.querySelector(
                            '[data-role-position]'
                        ).dataset.rolePosition;
                    roleDepartment.innerHTML =
                        grandparentElement.querySelector(
                            '[data-role-department]'
                        ).dataset.roleDepartment;
                    positionInput.value =
                        grandparentElement.querySelector(
                            '[data-role-position]'
                        ).dataset.rolePosition;
                    wrapperNode.classList.add('apply');
                });
            });
            // eslint-disable-next-line no-shadow
            applyClose.addEventListener('click', (event) => {
                const contactForm = document.querySelector('.wpcf7-form');
                event.preventDefault();
                applyFormWrapper.scrollTop = 0;
                wrapperNode.classList.remove('apply');
                inputLink.value = '';
                positionInput.value = '';
                contactForm.classList.remove('invalid');
            });
            // End -> Show Apply form
        })
        .catch(function (error) {
            console.error(
                'There has been a problem with your fetch operation:',
                error
            );
        });
};

//form?.addEventListener('submit', submitSearch);
cityInput?.addEventListener('change', submitSearch);
departmentInput?.addEventListener('change', submitSearch);

if(resourcesSearchRemove) {
    resourcesSearchRemove.addEventListener('click', () => {
        searchInput.value = ''; // Clear searchInput
        resourcesSearchRemove.classList.remove('active');
        liveSearch.innerHTML = '';
        submitSearch();
        searchResults.innerHTML = '';
    });
}

document.addEventListener('click', function(event) {
    const target = event.target;

    if ( !target.closest('#searchform') && target !== form) {
        liveSearch.style.display = 'none';
    }
});
if(searchInput) {
    searchInput.addEventListener('focus', function (event) {
        const searchValue = this.value.trim();
        if (searchValue.length >= 2) {
            liveSearch.style.display = 'flex';
        }
    });

    searchInput.addEventListener('input', function (event) {
        const searchValue = this.value.trim();
        // Check if the searchValue contains more than two characters
        if (searchValue.length >= 2) {
            submitSearch(event);
            liveSearch.style.display = 'flex';
        } else {
            liveSearch.style.display = 'none';
        }
    });
}

window.addEventListener('load', function() {
    submitSearch();
});

